import React from 'react';
import Terms from '../../components/Terms';

export default function Termo(props){
        return(
            <div>
                <Terms/>
            </div>
        )
}